import { NEWS_ARTICLES } from '@/features/actualidad-hostelera/articles'
import { LEARN_ARTICLES } from '@/features/aprender/articles'
import learnTopicHubSlugList from '@/navigation/learnTopicHubSlugs.json'

type RemapSection = 'aprender' | 'actualidad-hostelera'

function catalogFor(section: RemapSection) {
    return section === 'aprender' ? LEARN_ARTICLES : NEWS_ARTICLES
}

const LEARN_TOPIC_HUB_SLUGS = new Set(learnTopicHubSlugList)

/** Map ES article slug → EN slug when building public URLs. Throws in DEV if unmapped. */
export function enSlugFromEs(section: RemapSection, esSlug: string): string {
    if (section === 'aprender' && LEARN_TOPIC_HUB_SLUGS.has(esSlug)) return esSlug

    const article = catalogFor(section).find(a => a.slugs.es === esSlug)
    if (article) return article.slugs.en
    if (import.meta.env.DEV) {
        throw new Error(`Missing EN slug mapping for /${section}/${esSlug}`)
    }
    return esSlug
}

/**
 * Map EN article slug → ES slug for locale-free identity.
 * Unmapped inbound URLs keep the EN slug so the router can Navigate / 404.
 */
export function esSlugFromEn(section: RemapSection, enSlug: string): string {
    return catalogFor(section).find(a => a.slugs.en === enSlug)?.slugs.es ?? enSlug
}
